import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './ui/App'
import './index.css'
import { initTheme } from './utils/theme'
import { ToastProvider } from './ui/Toasts'
import { TenantProvider } from './tenant/TenantContext'
import { PermsProvider } from './auth/PermsContext'
import ErrorBoundary from './ui/ErrorBoundary'
import { BrowserRouter } from 'react-router-dom'
import { I18nProvider } from './i18n'

initTheme()

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename="/app">
      <ErrorBoundary>
        <I18nProvider>
          <ToastProvider>
            <TenantProvider>
              <PermsProvider>
                <App />
              </PermsProvider>
            </TenantProvider>
          </ToastProvider>
        </I18nProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
)

